import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AdminFormFieldDropdown } from "../../../../components/admin/formFields";
import {
  VIDEO_FORMAT_OPTIONS,
  VIDEO_RECORDING_CONSTANTS,
} from "../../constants";
import SingleCameraResolution from "../../../../assets/svg/single-camera-resolution.svg";
import SeparateCameraResolution from "../../../../assets/svg/separate-camera-resolution.svg";

interface VideoFormatResolutionProps {
  selectedCamera: string;
  label: string;
  model: string;
  values: any;
  errors: any;
  touched: any;
  setFieldValue: Function;
  handleBlur: Function;
  setFieldTouched: Function;
  videoResolution?: string;
  videoFormat?: string;
  cameraResolutionImage: string;
}

const VideoFormatResolution: FC<VideoFormatResolutionProps> = ({
  selectedCamera,
  label,
  model,
  values,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  errors,
  touched,
  videoResolution,
  videoFormat = "",
  cameraResolutionImage,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.management.camera_settings",
  });

  return (
    <div className="col-span-12 grid grid-cols-12 bg-gray-100 rounded-lg p-2">
      <h2 className="col-span-12 text-xs font-semibold leading-none mt-2">
        {label}
      </h2>
      <div className="col-span-4 p-2 space-y-4 text-xs font-semibold leading-none">
        <div className="w-full flex justify-between items-center text-gray-500">
          <p>{t("item")}</p>
          <p>{t("value")}</p>
        </div>
        <div className="w-full flex justify-between items-center">
          <p className="text-center">{t("format")}</p>
          {selectedCamera === "embedded_camera" ? (
            <AdminFormFieldDropdown
              label={""}
              id={`vr_${model}_embedded_videoFormat`}
              name={`vr_${model}_embedded_videoFormat`}
              options={VIDEO_FORMAT_OPTIONS}
              value={values[`vr_${model}_embedded_videoFormat`]}
              onChange={(e) => {
                setFieldValue(`vr_${model}_embedded_videoFormat`, e?.value);
              }}
              onBlur={(e) => {
                handleBlur(e);
                setFieldTouched(`vr_${model}_embedded_videoFormat`, true);
              }}
              error={errors[`vr_${model}_embedded_videoFormat`]}
              touched={touched[`vr_${model}_embedded_videoFormat`]}
              customWrapperClass="w-36"
            />
          ) : (
            <p>{videoFormat}</p>
          )}
        </div>
        <div className="w-full flex justify-between">
          <p>{t("resolution")}</p>
          <p>{videoResolution}</p>
        </div>
      </div>
      <div className="col-span-8 py-2 px-4 flex justify-center">
        <img
          src={cameraResolutionImage}
          alt="Camera"
          className="h-20 self-center"
        />
      </div>
    </div>
  );
};

export default VideoFormatResolution;
